import { __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import * as React from 'react';
import Caret from '../../assets/icons/Caret.esm.js';
import classNames from 'classnames';
import { noop } from 'lodash';
import NvMarkdownInline from '../../NvMarkdownInline/NvMarkdownInline.esm.js';
import useCloseEvents from '../../hooks/useCloseEvents.esm.js';
import { useTabs } from '../NvTabs.hooks.esm.js';

var NvTabsHeaderDropdown = React.forwardRef(function (_a, ref) {
    var _b;
    var tabs = _a.tabs;
    var _c = useTabs(), isCurrentTab = _c.isCurrentTab, selectTab = _c.selectTab;
    var tabSelected = React.useMemo(function () { return tabs.find(function (tab) { return isCurrentTab(tab.id); }); }, [isCurrentTab, tabs]);
    var refDropdown = React.useRef(null);
    var _d = useCloseEvents(refDropdown), handleClose = _d.handleClose, handleOpen = _d.handleOpen, isOpen = _d.isOpen, toggleOpen = _d.toggleOpen;
    var handleChange = function (tab, keyCode) {
        if (keyCode === void 0) { keyCode = ''; }
        if (keyCode && keyCode !== 'Enter')
            return;
        handleClose();
        selectTab(tab.id);
    };
    var tabSelectedProps = {
        'aria-disabled': tabSelected === null || tabSelected === void 0 ? void 0 : tabSelected.disabled,
        className: classNames('nv-subheading-2', 'input-div'),
        'data-testid': 'dropdown-name-tab',
    };
    return (React.createElement("div", { className: classNames('wrapper', (_b = {}, _b['wrapper-open'] = isOpen, _b)), "data-testid": "dropdown-wrapper", ref: ref },
        React.createElement("div", { className: "input-wrapper", "data-testid": "dropdown", onClick: toggleOpen, onKeyDown: handleOpen, role: "button", tabIndex: 0 },
            tabSelected.tabComponent ? (React.createElement("div", __assign({}, tabSelectedProps), tabSelected.tabComponent)) : (React.createElement(NvMarkdownInline, __assign({}, tabSelectedProps, { elementWrapper: "div" }), tabSelected.text)),
            React.createElement("input", { className: classNames('input'), "data-testid": "dropdown-input", readOnly: true, value: tabSelected.id }),
            React.createElement(Caret, { className: "icon", direction: isOpen ? 'up' : 'down' })),
        isOpen && (React.createElement("ul", { className: "dropdown-wrapper", "data-testid": "dropdown-list", ref: refDropdown }, tabs.map(function (tab, tabIndex) {
            var _a;
            var buttonProps = {
                'aria-disabled': tab.disabled,
                'aria-label': tab.text,
                className: classNames('nv-subheading-2', 'dropdown-item-button'),
                'data-testid': "dropdown-item-button-".concat(tabIndex),
                onClick: !tab.disabled ? function () { return handleChange(tab); } : noop,
                onKeyDown: !tab.disabled
                    ? function (event) { return handleChange(tab, event.key); }
                    : noop,
            };
            return (React.createElement("li", { className: classNames('dropdown-item', (_a = {},
                    _a['disabled'] = tab.disabled,
                    _a['item-selected'] = isCurrentTab(tab.id),
                    _a)), "data-testid": "dropdown-list-item", key: tab.id }, tab.tabComponent ? (React.createElement("button", __assign({}, buttonProps), tab.tabComponent)) : (React.createElement(NvMarkdownInline, __assign({ elementWrapper: "button" }, buttonProps), tab.text))));
        })))));
});
NvTabsHeaderDropdown.displayName = 'NvTabsHeaderDropdown';

export { NvTabsHeaderDropdown };
//# sourceMappingURL=NvTabsHeaderDropdown.esm.js.map
